const quickLinksArray = [
    {
        menuTitle: 'Sales',
        submenu: [
            {
                submenuTitle: 'Invoice',
                url: '/sales/invoice/new'
            },
            {
                submenuTitle: 'Credit Note',
                url: '/sales/creditnote/new'
            },
            {
                submenuTitle: 'Year Ending',
                url: '/financialyear/yearendingprocess'
            }
        ]
    },
    {
        menuTitle: 'Bank / Cash',
        submenu: [
            {
                submenuTitle: 'Bank',
                url: '/bank/new'
            },
            {
                submenuTitle: 'Bank Transaction',
                url: '/banktransaction'
            },
            {
                submenuTitle: 'Receipt',
                url: '/receipt/new'
            },
            {
                submenuTitle: 'Payment',
                url: '/payment/new'
            }
        ]
    },
    {
        menuTitle: 'Purchase',
        submenu: [
            {
                submenuTitle: 'Supplier Bill',
                url: '/purchase/bill/new'
            },
            {
                submenuTitle: 'Debit Note',
                url: '/purchase/debitnote/new'
            }
        ]
    },
    {
        menuTitle: 'Contact',
        submenu: [
            {
                submenuTitle: 'Contact',
                url: '/contact/'
            }
        ]
    },
    {
        menuTitle: 'Inventory',
        submenu: [
            {
                submenuTitle: 'Product',
                url: '/product/new'
            },
            {
                submenuTitle: 'Stock Transfer',
                url: '/stocktransfer/new'
            },
            {
                submenuTitle: 'Price Master',
                url: '/report/stockmasterprice'
            }
        ]
    }
];

export default quickLinksArray;
